import comp from "./TheatreMode";
export default comp;
